/* SmartWash car picker: make / model / seats dropdowns with a rotating 3D car
   matched to the body shape, then "Is this the right car?" before booking.
   Mount point: <div data-sw-pick data-services-url="/collections/services"></div> */
(function () {
  'use strict';

  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var GOLD = '#D3BE81';

  /* ---- Body shapes -------------------------------------------------------
     label: shown to the customer.  tier 'suv': always gets the higher price list (vans).
     Any vehicle with 7 or more seats also gets the higher price list.
     Dimensions are in metres; x runs along the car, positive towards the front. */
  var BODIES = {
    h: { label: 'Hatchback', L: 4.05, W: 1.75, g: .17, wr: .31, xf: 1.25, xr: -1.25, hb: .92, hn: .80, ht: .92, hr: 1.46, F0: .72, F1: .12, R1: -1.55, R0: -1.93, pillars: [-.38] },
    s: { label: 'Saloon', L: 4.70, W: 1.82, g: .16, wr: .32, xf: 1.42, xr: -1.38, hb: .93, hn: .80, ht: .95, hr: 1.43, F0: .85, F1: .20, R1: -.95, R0: -1.55, pillars: [-.30] },
    e: { label: 'Estate', L: 4.75, W: 1.82, g: .16, wr: .32, xf: 1.45, xr: -1.38, hb: .93, hn: .80, ht: .93, hr: 1.46, F0: .90, F1: .25, R1: -2.02, R0: -2.28, pillars: [-.25, -1.25] },
    c: { label: 'Coupe', L: 4.45, W: 1.84, g: .13, wr: .33, xf: 1.33, xr: -1.30, hb: .86, hn: .72, ht: .88, hr: 1.30, F0: .62, F1: -.08, R1: -.72, R0: -1.72, pillars: [-.55] },
    v: { label: 'Convertible', L: 4.20, W: 1.78, g: .13, wr: .32, xf: 1.27, xr: -1.22, hb: .86, hn: .72, ht: .90, hr: 1.24, F0: .58, F1: .16, open: true },
    u: { label: 'SUV', L: 4.55, W: 1.88, g: .23, wr: .37, xf: 1.35, xr: -1.32, hb: 1.08, hn: .98, ht: 1.08, hr: 1.68, F0: .80, F1: .22, R1: -1.85, R0: -2.18, pillars: [-.28, -1.22] },
    m: { label: 'MPV', L: 4.65, W: 1.85, g: .17, wr: .33, xf: 1.45, xr: -1.35, hb: 1.00, hn: .85, ht: 1.00, hr: 1.70, F0: 1.38, F1: .55, R1: -2.08, R0: -2.25, pillars: [.22, -.98] },
    n: { label: 'Van', L: 5.00, W: 1.95, g: .18, wr: .35, xf: 1.60, xr: -1.45, hb: 1.05, hn: .95, ht: 1.05, hr: 1.95, F0: 1.72, F1: 1.05, R1: -2.38, R0: -2.44, pillars: [], glassFrom: .30, tier: 'suv' },
    p: { label: 'Pickup', L: 5.25, W: 1.90, g: .24, wr: .38, xf: 1.65, xr: -1.55, hb: 1.08, hn: 1.00, ht: 1.08, hr: 1.78, F0: 1.00, F1: .50, R1: -.75, R0: -.86, pillars: [-.10], bed: true }
  };
  var BODY_ORDER = ['h', 's', 'e', 'c', 'v', 'u', 'm', 'n', 'p'];

  /* ---- Popular UK makes and models --------------------------------------
     "Model:<shape><usual seats>". Shapes: h hatchback, s saloon, e estate, c coupe,
     v convertible, u SUV, m MPV / people carrier, n van, p pickup.
     Seats are the usual number; the customer can change them. */
  var CARS = {
    'Abarth': '500 / 595:h4',
    'Alfa Romeo': 'MiTo:h4,Giulietta:h5,Giulia:s5,Stelvio:u5,Tonale:u5,Junior:u5',
    'Audi': 'A1:h5,A3:h5,A3 Saloon:s5,A4:s5,A4 Avant:e5,A5 Coupe:c4,A5 Sportback:h5,A6:s5,A6 Avant:e5,A7:h5,A8:s5,Q2:u5,Q3:u5,Q4 e-tron:u5,Q5:u5,Q7:u7,Q8:u5,Q8 e-tron:u5,TT:c4,e-tron GT:s5,R8:c2',
    'BMW': '1 Series:h5,2 Series Coupe:c4,2 Series Gran Coupe:s5,2 Series Active Tourer:m5,2 Series Gran Tourer:m7,3 Series:s5,3 Series Touring:e5,4 Series Coupe:c4,4 Series Convertible:v4,4 Series Gran Coupe:h5,5 Series:s5,5 Series Touring:e5,7 Series:s5,X1:u5,X2:u5,X3:u5,X4:u5,X5:u5,X6:u5,X7:u7,Z4:v2,i3:h4,i4:s5,iX:u5,iX1:u5,iX3:u5',
    'BYD': 'Dolphin:h5,Atto 3:u5,Seal:s5,Seal U:u5',
    'Citroen': 'C1:h4,C3:h5,C3 Aircross:u5,C4:h5,C4 Cactus:h5,C4 Picasso / SpaceTourer:m5,Grand C4 Picasso / SpaceTourer:m7,C5 Aircross:u5,Berlingo:m5,Berlingo Van:n3,Dispatch:n3,Relay:n3',
    'Cupra': 'Born:h5,Leon:h5,Formentor:u5,Ateca:u5,Terramar:u5',
    'Dacia': 'Sandero:h5,Sandero Stepway:h5,Logan MCV:e5,Duster:u5,Jogger:e7,Spring:h4,Bigster:u5',
    'DS': 'DS 3:h5,DS 4:h5,DS 7:u5',
    'Fiat': '500:h4,500e:h4,500X:u5,500L:m5,600:u5,Panda:h4,Punto:h5,Tipo:h5,Doblo:m5,Ducato:n3',
    'Ford': 'Ka:h4,Ka+:h5,Fiesta:h5,Focus:h5,Focus Estate:e5,Mondeo:h5,Mondeo Estate:e5,Puma:u5,EcoSport:u5,Kuga:u5,Edge:u5,Explorer:u5,Mustang:c4,Mustang Mach-E:u5,B-Max:m5,C-Max:m5,Grand C-Max:m7,S-Max:m7,Galaxy:m7,Tourneo Connect:m5,Tourneo Custom:m8,Ranger:p5,Transit Courier:n2,Transit Connect:n3,Transit Custom:n3,Transit:n3',
    'Honda': 'Jazz:h5,Civic:h5,Accord:s5,HR-V:u5,ZR-V:u5,CR-V:u5,Honda e:h4,e:Ny1:u5',
    'Hyundai': 'i10:h5,i20:h5,i30:h5,i30 Tourer:e5,i40:e5,ix20:m5,ix35:u5,Bayon:u5,Kona:u5,Tucson:u5,Santa Fe:u7,Ioniq:h5,Ioniq 5:u5,Ioniq 6:s5',
    'Jaguar': 'XE:s5,XF:s5,XF Sportbrake:e5,XJ:s5,F-Type:c2,E-Pace:u5,F-Pace:u5,I-Pace:u5',
    'Jeep': 'Avenger:u5,Renegade:u5,Compass:u5,Wrangler:u5,Grand Cherokee:u5',
    'KGM / SsangYong': 'Tivoli:u5,Korando:u5,Rexton:u7,Musso:p5',
    'Kia': 'Picanto:h5,Rio:h5,Ceed:h5,Ceed Sportswagon:e5,ProCeed:e5,XCeed:u5,Stonic:u5,Soul:u5,Niro:u5,Sportage:u5,Sorento:u7,EV3:u5,EV6:u5,EV9:u7,Venga:m5,Carens:m7',
    'Land Rover': 'Defender:u5,Discovery:u7,Discovery Sport:u7,Freelander:u5,Range Rover:u5,Range Rover Sport:u5,Range Rover Evoque:u5,Range Rover Velar:u5',
    'Lexus': 'CT:h5,IS:s5,ES:s5,LBX:u5,UX:u5,NX:u5,RX:u5',
    'Mazda': 'Mazda2:h5,Mazda3:h5,Mazda6:s5,CX-3:u5,CX-30:u5,CX-5:u5,CX-60:u5,CX-80:u7,MX-30:u5,MX-5:v2',
    'Mercedes-Benz': 'A-Class:h5,A-Class Saloon:s5,B-Class:m5,C-Class:s5,C-Class Estate:e5,C-Class Coupe:c4,CLA:s5,CLS:s5,E-Class:s5,E-Class Estate:e5,S-Class:s5,GLA:u5,GLB:u7,GLC:u5,GLE:u5,GLS:u7,G-Class:u5,EQA:u5,EQB:u7,EQC:u5,EQE:s5,EQS:s5,SLK / SLC:v2,V-Class:m7,Citan:n2,Vito:n3,Sprinter:n3',
    'MG': 'MG3:h5,MG4:h5,MG5:e5,ZS:u5,HS:u5,Cyberster:v2',
    'MINI': 'Hatch 3-door:h4,Hatch 5-door:h5,Convertible:v4,Clubman:e5,Countryman:u5,Aceman:u5',
    'Mitsubishi': 'Mirage:h5,ASX:u5,Eclipse Cross:u5,Outlander:u5,Shogun:u7,L200:p5',
    'Nissan': 'Micra:h5,Note:h5,Pulsar:h5,Leaf:h5,Juke:u5,Qashqai:u5,X-Trail:u5,Ariya:u5,Navara:p5,NV200:n2',
    'Peugeot': '107:h4,108:h4,207:h5,208:h5,2008:u5,308:h5,308 SW:e5,3008:u5,508:s5,508 SW:e5,5008:u7,Rifter:m5,Partner:n3,Expert:n3,Boxer:n3',
    'Polestar': 'Polestar 2:s5,Polestar 3:u5,Polestar 4:u5',
    'Porsche': '911:c4,718 Boxster:v2,718 Cayman:c2,Panamera:s4,Taycan:s4,Macan:u5,Cayenne:u5',
    'Renault': 'Twingo:h4,Clio:h5,Renault 5:h5,Zoe:h5,Megane:h5,Captur:u5,Kadjar:u5,Arkana:u5,Austral:u5,Symbioz:u5,Scenic:m5,Grand Scenic:m7,Kangoo:n2,Trafic:n3,Master:n3',
    'SEAT': 'Mii:h4,Ibiza:h5,Leon:h5,Leon Estate:e5,Arona:u5,Ateca:u5,Tarraco:u7,Alhambra:m7',
    'Skoda': 'Citigo:h4,Fabia:h5,Scala:h5,Rapid:h5,Octavia:h5,Octavia Estate:e5,Superb:h5,Superb Estate:e5,Yeti:u5,Kamiq:u5,Karoq:u5,Kodiaq:u7,Enyaq:u5,Elroq:u5',
    'Smart': 'Fortwo:h2,Forfour:h4,#1:u5,#3:u5',
    'Subaru': 'Impreza:h5,XV / Crosstrek:u5,Forester:u5,Outback:e5',
    'Suzuki': 'Celerio:h5,Ignis:h5,Swift:h5,Baleno:h5,Vitara:u5,S-Cross:u5,Jimny:u4,Swace:e5,Across:u5',
    'Tesla': 'Model 3:s5,Model S:s5,Model X:u5,Model Y:u5',
    'Toyota': 'Aygo:h4,Aygo X:h4,Yaris:h5,Yaris Cross:u5,Auris:h5,Corolla:h5,Corolla Touring Sports:e5,Avensis:s5,Prius:h5,Prius+:m7,Verso:m7,C-HR:u5,RAV4:u5,bZ4X:u5,Highlander:u7,Land Cruiser:u7,GT86 / GR86:c4,Hilux:p5,Proace:n3,Proace Verso:m8',
    'Vauxhall': 'Adam:h4,Viva:h5,Corsa:h5,Astra:h5,Astra Sports Tourer:e5,Insignia:h5,Insignia Sports Tourer:e5,Mokka:u5,Crossland:u5,Grandland:u5,Frontera:u5,Meriva:m5,Zafira:m7,Combo Life:m5,Combo:n3,Vivaro:n3,Movano:n3',
    'Volkswagen': 'up!:h4,Polo:h5,Golf:h5,Golf Estate:e5,Beetle:h4,Scirocco:c4,Passat:s5,Passat Estate:e5,Arteon:s5,ID.3:h5,ID.4:u5,ID.5:u5,ID.7:s5,ID. Buzz:m5,T-Cross:u5,T-Roc:u5,Taigo:u5,Tiguan:u5,Tiguan Allspace:u7,Touareg:u5,Touran:m7,Sharan:m7,Caddy:n2,Caddy Life:m5,Transporter:n3,Caravelle:m7,Crafter:n3,Amarok:p5',
    'Volvo': 'V40:h5,S60:s5,S90:s5,V60:e5,V90:e5,EX30:u5,XC40:u5,C40:u5,XC60:u5,XC90:u7,EX90:u7'
  };
  var OTHER = 'Other / not listed';
  var SEATS = [2, 3, 4, 5, 6, 7, 8, 9];

  function modelsFor(make) {
    return (CARS[make] || '').split(',').filter(Boolean).map(function (item) {
      var i = item.lastIndexOf(':');
      return { name: item.slice(0, i), body: item.charAt(i + 1), seats: parseInt(item.slice(i + 2), 10) };
    });
  }

  /* ---- Geometry shared by the 3D car and the flat fallback --------------- */
  function lerp(a, b, t) { return a + (b - a) * t; }

  function lowerProfile(c) {
    var h = c.L / 2, g = c.g, pts = [];
    pts.push([-h + .06, g], [-h, g + .2], [-h + .02, c.ht - .06], [-h + .09, c.ht], [c.F0, c.hb]);
    var nx = h - .28;
    pts.push([(c.F0 + nx) / 2, (c.hb + c.hn) / 2 + .025], [nx, c.hn], [h - .04, c.hn - .1], [h, c.hn - .28], [h - .02, g + .12], [h - .1, g]);
    [c.xf, c.xr].forEach(function (cx) {
      var ra = c.wr + .075, a0 = Math.asin((g - c.wr) / ra);
      for (var i = 0; i <= 12; i++) {
        var a = a0 + (Math.PI - 2 * a0) * i / 12;
        pts.push([cx + ra * Math.cos(a), c.wr + ra * Math.sin(a)]);
      }
    });
    return pts;
  }
  function deckY(c, x) { var x0 = -c.L / 2 + .09; return lerp(c.ht, c.hb, (x - x0) / (c.F0 - x0)); }
  function cabinProfile(c) {
    return [[c.R0, deckY(c, c.R0) - .03], [c.R1, c.hr - .04], [(c.F1 + c.R1) / 2, c.hr], [c.F1, c.hr - .03], [c.F0, c.hb - .03]];
  }
  /* x position of the windscreen (front) or rear screen edge at height y */
  function frontX(c, y) { return lerp(c.F0, c.F1, (y - (c.hb - .03)) / (c.hr - .03 - (c.hb - .03))); }
  function rearX(c, y) { var y0 = deckY(c, c.R0) - .03; return lerp(c.R0, c.R1, (y - y0) / (c.hr - .04 - y0)); }
  function glassBand(c, inset) {
    var yb = c.hb + .05, yt = c.hr - .12;
    var rb = c.glassFrom != null ? c.glassFrom : rearX(c, yb) + inset;
    var rt = c.glassFrom != null ? c.glassFrom : rearX(c, yt) + inset;
    return [[rb, yb], [rt, yt], [frontX(c, yt) - inset, yt], [frontX(c, yb) - inset, yb]];
  }
  function clipX(poly, x, keepGreater) {
    var out = [];
    for (var i = 0; i < poly.length; i++) {
      var a = poly[i], b = poly[(i + 1) % poly.length];
      var ain = keepGreater ? a[0] >= x : a[0] <= x, bin = keepGreater ? b[0] >= x : b[0] <= x;
      if (ain) out.push(a);
      if (ain !== bin) { var t = (x - a[0]) / (b[0] - a[0]); out.push([x, lerp(a[1], b[1], t)]); }
    }
    return out;
  }
  function sideWindows(c) {
    if (c.open) return [];
    var band = glassBand(c, .10), cuts = (c.pillars || []).slice().sort(function (a, b) { return a - b; }), wins = [];
    var edges = [-99].concat(cuts, [99]);
    for (var i = 0; i < edges.length - 1; i++) {
      var p = clipX(clipX(band, edges[i] + .035, true), edges[i + 1] - .035, false);
      if (p.length >= 3) wins.push(p);
    }
    return wins;
  }

  /* ---- 3D car ------------------------------------------------------------ */
  function buildCar(T, code, colour) {
    var c = BODIES[code], h = c.L / 2, car = new T.Group();
    var paint = new T.MeshStandardMaterial({ color: colour, metalness: .3, roughness: .36 });
    var glass = new T.MeshStandardMaterial({ color: 0x0b0e13, metalness: .5, roughness: .12 });
    var dark = new T.MeshStandardMaterial({ color: 0x101010, roughness: .9 });
    var tyre = new T.MeshStandardMaterial({ color: 0x0c0c0c, roughness: .85 });
    var alloy = new T.MeshStandardMaterial({ color: 0xc9ccd1, metalness: .55, roughness: .3 });

    function extrude(pts, width, bevel, mat) {
      var s = new T.Shape();
      pts.forEach(function (p, i) { if (i) s.lineTo(p[0], p[1]); else s.moveTo(p[0], p[1]); });
      var depth = width - 2 * bevel;
      var geo = new T.ExtrudeGeometry(s, { depth: depth, bevelEnabled: bevel > 0, bevelThickness: bevel, bevelSize: bevel, bevelOffset: -bevel, bevelSegments: 3 });
      geo.translate(0, 0, -depth / 2);
      var m = new T.Mesh(geo, mat); car.add(m); return m;
    }
    function box(w, hgt, d, x, y, z, mat) {
      var m = new T.Mesh(new T.BoxGeometry(w, hgt, d), mat); m.position.set(x, y, z); car.add(m); return m;
    }

    extrude(lowerProfile(c), c.W, .06, paint);
    var floorTop = Math.min(c.hn, c.ht, c.hb) - .2;
    box(c.L - .6, floorTop - c.g, c.W - .5, 0, (floorTop + c.g) / 2, 0, dark);

    var cw = c.W * .86;
    if (!c.open) {
      extrude(cabinProfile(c), cw, .05, paint);
      var core = glassBand(c, -.014);
      if (c.glassFrom != null) core = clipX(core, c.glassFrom + .1, true);
      extrude(core, cw - .26, 0, glass);
      sideWindows(c).forEach(function (w) { extrude(w, cw + .014, 0, glass); });
    } else {
      /* open top: windscreen, two seats and a dark cockpit */
      extrude([[c.F0, c.hb - .02], [c.F0 + .05, c.hb - .02], [c.F1 + .05, c.hr], [c.F1, c.hr]], cw - .12, 0, glass);
      box(1.25, .04, cw - .3, -.25, c.hb + .005, 0, dark);
      [-1, 1].forEach(function (s) {
        box(.16, .42, .44, -.42, c.hb + .16, s * .36, dark);
        box(.42, .1, .44, -.2, c.hb + .04, s * .36, dark);
      });
    }
    if (c.bed) box(-.98 - (-h + .2), .03, c.W - .34, (-.98 + (-h + .2)) / 2, c.ht + .005, 0, dark);

    /* wheels */
    [c.xf, c.xr].forEach(function (x) {
      [-1, 1].forEach(function (s) {
        var t = new T.Mesh(new T.CylinderGeometry(c.wr, c.wr, .22, 28), tyre);
        t.rotation.x = Math.PI / 2; t.position.set(x, c.wr, s * (c.W / 2 - .12)); car.add(t);
        var a = new T.Mesh(new T.CylinderGeometry(c.wr * .62, c.wr * .62, .235, 20), alloy);
        a.rotation.x = Math.PI / 2; a.position.copy(t.position); car.add(a);
        var cap = new T.Mesh(new T.CylinderGeometry(c.wr * .2, c.wr * .2, .245, 12), dark);
        cap.rotation.x = Math.PI / 2; cap.position.copy(t.position); car.add(cap);
      });
    });

    /* lights, grille, plates, mirrors */
    var head = new T.MeshStandardMaterial({ color: 0xffffff, emissive: 0xfff3d0, emissiveIntensity: .9 });
    var tail = new T.MeshStandardMaterial({ color: 0xb01010, emissive: 0xd01818, emissiveIntensity: .8 });
    var plateF = new T.MeshStandardMaterial({ color: 0xf4f4f4, emissive: 0x777777 });
    var plateR = new T.MeshStandardMaterial({ color: 0xf2c400, emissive: 0x6b5600 });
    [-1, 1].forEach(function (s) {
      box(.1, .1, .34, h - .062, c.hn - .15, s * (c.W / 2 - .3), head);
      box(.08, .11, .3, -h + .045, c.ht - .17, s * (c.W / 2 - .28), tail);
      box(.14, .09, .1, c.F0 - .05, c.hb + .05, s * (c.W / 2 - .01), paint);
    });
    box(.06, .13, c.W - 1.05, h - .018, c.hn - .34, 0, dark);
    box(.03, .1, .46, h - .012, c.g + .2, 0, plateF);
    box(.03, .1, .46, -h + .012, c.g + .34, 0, plateR);
    return car;
  }

  function Viewer(holder, colour) {
    var T = window.THREE, self = this;
    var renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputEncoding = T.sRGBEncoding;
    holder.appendChild(renderer.domElement);
    var scene = new T.Scene();
    var camera = new T.PerspectiveCamera(27, 1.6, .1, 60);
    scene.add(new T.HemisphereLight(0xffffff, 0x2a2620, .55));
    var key = new T.DirectionalLight(0xffffff, .8); key.position.set(4, 6, 5); scene.add(key);
    var rim = new T.DirectionalLight(0xd3be81, .55); rim.position.set(-5, 3, -4); scene.add(rim);

    var turntable = new T.Group(); scene.add(turntable);
    var ring = new T.Mesh(new T.RingGeometry(2.72, 2.76, 96), new T.MeshBasicMaterial({ color: 0xd3be81, transparent: true, opacity: .8, side: T.DoubleSide }));
    ring.rotation.x = -Math.PI / 2; ring.position.y = .002; scene.add(ring);
    var disc = new T.Mesh(new T.CircleGeometry(2.72, 96), new T.MeshBasicMaterial({ color: 0xd3be81, transparent: true, opacity: .05 }));
    disc.rotation.x = -Math.PI / 2; scene.add(disc);
    var cv = document.createElement('canvas'); cv.width = cv.height = 128;
    var cx = cv.getContext('2d'), grad = cx.createRadialGradient(64, 64, 8, 64, 64, 64);
    grad.addColorStop(0, 'rgba(0,0,0,.75)'); grad.addColorStop(1, 'rgba(0,0,0,0)');
    cx.fillStyle = grad; cx.fillRect(0, 0, 128, 128);
    var shadow = new T.Mesh(new T.PlaneGeometry(1, 1), new T.MeshBasicMaterial({ map: new T.CanvasTexture(cv), transparent: true, depthWrite: false }));
    shadow.rotation.x = -Math.PI / 2; shadow.position.y = .004; turntable.add(shadow);

    var car = null, grow = 1, dragging = false, lastX = 0, lastT = 0, raf = 0, running = false;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function resize() {
      var w = holder.clientWidth || 300, hgt = holder.clientHeight || 200;
      renderer.setSize(w, hgt, false);
      camera.aspect = w / hgt;
      /* pull the camera back on narrow screens so the whole turntable stays in view */
      var dist = Math.max(7.7, 3.35 / (Math.tan(13.5 * Math.PI / 180) * camera.aspect));
      camera.position.set(0, dist * .3, dist); camera.lookAt(0, .62, 0);
      camera.updateProjectionMatrix();
    }
    function frame(t) {
      raf = requestAnimationFrame(frame);
      var dt = Math.min(.05, (t - lastT) / 1000 || 0); lastT = t;
      if (!dragging && !still) turntable.rotation.y += dt * .55;
      if (grow < 1) { grow = Math.min(1, grow + dt * 3.2); var k = 1 - Math.pow(1 - grow, 3); turntable.scale.setScalar(.82 + .18 * k); }
      renderer.render(scene, camera);
    }
    this.show = function (code) {
      if (car) { turntable.remove(car); car.traverse(function (o) { if (o.geometry) o.geometry.dispose(); }); }
      car = buildCar(T, code, colour); turntable.add(car);
      shadow.scale.set(BODIES[code].L * 1.25, BODIES[code].W * 1.7, 1);
      grow = 0; turntable.scale.setScalar(.82);
      if (still) turntable.rotation.y = -.75;
      resize(); self.start();
    };
    this.start = function () { if (!running) { running = true; lastT = performance.now(); raf = requestAnimationFrame(frame); } };
    this.stop = function () { running = false; cancelAnimationFrame(raf); };

    var el = renderer.domElement;
    el.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; try { el.setPointerCapture(e.pointerId); } catch (x) {} });
    el.addEventListener('pointermove', function (e) { if (dragging) { turntable.rotation.y += (e.clientX - lastX) * .012; lastX = e.clientX; } });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (n) { el.addEventListener(n, function () { dragging = false; }); });
    if (window.ResizeObserver) new ResizeObserver(resize).observe(holder); else window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', function () { if (document.hidden) self.stop(); else if (car) self.start(); });
  }

  /* Flat side view that turns on the spot, used if 3D is unavailable on the device */
  function FlatViewer(holder, colour) {
    holder.classList.add('sw-pick__canvas--flat');
    this.show = function (code) {
      var c = BODIES[code], h = c.L / 2;
      function path(pts) { return 'M' + pts.map(function (p) { return (p[0] + h).toFixed(3) + ' ' + (2.1 - p[1]).toFixed(3); }).join('L') + 'Z'; }
      var svg = '<svg viewBox="-0.2 0 ' + (c.L + .4).toFixed(2) + ' 2.3" role="img" aria-label="' + c.label + '">';
      if (!c.open) svg += '<path d="' + path(cabinProfile(c)) + '" fill="' + colour + '"/>';
      else svg += '<path d="' + path([[c.F0, c.hb], [c.F0 + .06, c.hb], [c.F1 + .06, c.hr], [c.F1, c.hr]]) + '" fill="#0b0e13"/>';
      sideWindows(c).forEach(function (w) { svg += '<path d="' + path(w) + '" fill="#0b0e13"/>'; });
      svg += '<path d="' + path(lowerProfile(c)) + '" fill="' + colour + '"/>';
      [c.xf, c.xr].forEach(function (x) {
        svg += '<circle cx="' + (x + h) + '" cy="' + (2.1 - c.wr) + '" r="' + c.wr + '" fill="#0c0c0c"/><circle cx="' + (x + h) + '" cy="' + (2.1 - c.wr) + '" r="' + (c.wr * .6) + '" fill="#c9ccd1"/>';
      });
      holder.innerHTML = svg + '</svg>';
    };
    this.start = this.stop = function () {};
  }

  var threeJob = null;
  function loadThree() {
    if (window.THREE) return Promise.resolve();
    if (threeJob) return threeJob;
    threeJob = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = THREE_URL; s.async = true; s.onload = function () { window.THREE ? resolve() : reject(); }; s.onerror = reject;
      document.head.appendChild(s);
    });
    return threeJob;
  }

  /* ---- Styles ------------------------------------------------------------ */
  var CSS = [
    '.sw-pick,.sw-pick *{box-sizing:border-box}',
    '.sw-pick{width:100%;max-width:480px;margin:44px auto 0;text-align:center;font-family:var(--font-body--family,Inter,sans-serif);letter-spacing:normal;color:#F1F1F1}',
    'div:has(>.sw-pick){width:100%}',
    '.sw-pick [hidden]{display:none!important}',
    '.sw-pick__label{margin:0 0 10px;color:#F1F1F1;font-size:18px;line-height:27px;font-weight:600}',
    '.sw-pick__grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}',
    '.sw-pick__grid>:nth-child(n+3){grid-column:1/-1}',
    '@media (max-width:479px){.sw-pick__grid{grid-template-columns:1fr}}',
    '.sw-pick .sw-pick__select,.sw-pick .sw-pick__text{display:block;width:100%;height:56px;margin:0;padding:0 44px 0 22px;border:0;border-radius:9999px;outline:0;box-shadow:none;background-color:#51442E;color:' + GOLD + ';font:500 16px/24px var(--font-body--family,Inter,sans-serif);text-align:left;text-overflow:ellipsis;cursor:pointer;-webkit-appearance:none;appearance:none;transition:background-color .15s,color .15s}',
    '.sw-pick .sw-pick__select{background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 12 8\'%3E%3Cpath d=\'M1 1l5 5 5-5\' fill=\'none\' stroke=\'%23D3BE81\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 20px center;background-size:12px 8px}',
    '.sw-pick .sw-pick__text{padding:0 22px;cursor:text}',
    '.sw-pick .sw-pick__text::placeholder{color:' + GOLD + ';opacity:.75}',
    '.sw-pick .sw-pick__select:focus-visible,.sw-pick .sw-pick__text:focus-visible{box-shadow:0 0 0 2px ' + GOLD + '}',
    '.sw-pick .sw-pick__select:disabled{opacity:.55;cursor:not-allowed}',
    '.sw-pick .sw-pick__select option{background:#fff;color:#0F0F0F}',
    '.sw-pick__error{margin:12px 0 0;color:#F87171;font-size:14px;line-height:20px}',
    '.sw-pick__stage{margin-top:16px;padding:8px 20px 20px;border:1px solid rgba(241,241,241,.1);border-radius:24px;background:radial-gradient(ellipse at 50% 38%,#3a3323,#171717 72%);animation:sw-pick-in .35s ease-out}',
    '@keyframes sw-pick-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '.sw-pick__canvas{position:relative;width:100%;height:240px;touch-action:pan-y;cursor:grab}',
    '.sw-pick__canvas:active{cursor:grabbing}',
    '.sw-pick__canvas canvas{display:block;width:100%;height:100%}',
    '.sw-pick__canvas--flat{display:flex;align-items:center;justify-content:center;perspective:900px;cursor:default}',
    '.sw-pick__canvas--flat svg{width:82%;animation:sw-pick-turn 9s linear infinite}',
    '@keyframes sw-pick-turn{to{transform:rotateY(360deg)}}',
    '@media (prefers-reduced-motion:reduce){.sw-pick__canvas--flat svg,.sw-pick__stage{animation:none}}',
    '.sw-pick__hint{margin:-4px 0 10px;color:rgba(241,241,241,.55);font-size:12px;line-height:16px}',
    '.sw-pick__name{margin:0;color:#F1F1F1;font-size:20px;line-height:28px;font-weight:700}',
    '.sw-pick__meta{margin:2px 0 0;color:' + GOLD + ';font-size:14px;line-height:20px;font-weight:500}',
    '.sw-pick__price{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin:12px 0 0}',
    '.sw-pick__price span{padding:6px 14px;border:1px solid rgba(211,190,129,.35);border-radius:9999px;background:rgba(15,15,15,.45);color:rgba(241,241,241,.85);font-size:14px;line-height:20px;white-space:nowrap}',
    '.sw-pick__price b{margin-left:6px;color:' + GOLD + ';font-weight:700}',
    '.sw-pick__question{margin:16px 0 0;color:#F1F1F1;font-size:16px;line-height:24px;font-weight:600}',
    '.sw-pick__choices{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-top:14px}',
    '@media (max-width:420px){.sw-pick__choices{grid-template-columns:1fr}.sw-pick__stage{padding:8px 16px 16px}}',
    '.sw-pick .sw-pick__btn{display:inline-flex;align-items:center;justify-content:center;width:100%;min-height:48px;margin:0;padding:12px 16px;border:1px solid ' + GOLD + ';border-radius:9999px;background:' + GOLD + ';box-shadow:none;color:#0F0F0F;font:600 16px/24px var(--font-body--family,Inter,sans-serif);text-decoration:none;cursor:pointer;-webkit-appearance:none;appearance:none;transition:background-color .15s,color .15s}',
    '.sw-pick .sw-pick__btn:hover{background:#1A1A1A;color:#F1F1F1}',
    '.sw-pick .sw-pick__btn--ghost{border-color:rgba(241,241,241,.3);background:transparent;color:#F1F1F1}',
    '.sw-pick .sw-pick__btn--ghost:hover{background:rgba(241,241,241,.1)}',
    '.sw-pick .sw-pick__btn--main{height:56px;margin-top:20px;padding:12px 40px}',
    '.sw-pick .sw-pick__btn:disabled{opacity:.5;pointer-events:none}',
    '.sw-pick__fix{margin-top:14px;text-align:left}',
    '.sw-pick__fix p{margin:0 0 8px;color:rgba(241,241,241,.8);font-size:14px;line-height:20px;text-align:center}'
  ].join('');

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function select(label, placeholder) {
    var s = el('select', 'sw-pick__select'); s.setAttribute('aria-label', label);
    var o = el('option', '', placeholder); o.value = ''; s.appendChild(o); return s;
  }
  function fill(sel, items) {
    while (sel.options.length > 1) sel.remove(1);
    items.forEach(function (it) { var o = el('option', '', it[1]); o.value = it[0]; sel.appendChild(o); });
    sel.value = '';
  }

  function init(root) {
    if (root.dataset.swReady) return;
    root.dataset.swReady = '1';
    root.classList.add('sw-pick');
    var servicesUrl = root.dataset.servicesUrl || '/collections/services';
    var colour = root.dataset.carColour || '#DDE0E5';
    if (!document.getElementById('sw-pick-css')) { var st = el('style'); st.id = 'sw-pick-css'; st.textContent = CSS; document.head.appendChild(st); }

    var heading = el('h2', 'sw-pick__label', root.dataset.heading || 'Find services for your vehicle');
    var grid = el('div', 'sw-pick__grid');
    var makeSel = select('Vehicle make', 'Select make');
    var modelSel = select('Vehicle model', 'Select model');
    var seatSel = select('Number of seats', 'Number of seats');
    var otherText = el('input', 'sw-pick__text'); otherText.type = 'text'; otherText.maxLength = 40; otherText.placeholder = 'Your make and model (optional)';
    otherText.setAttribute('aria-label', 'Your make and model'); otherText.hidden = true;
    fill(makeSel, Object.keys(CARS).map(function (m) { return [m, m]; }).concat([[OTHER, OTHER]]));
    fill(seatSel, SEATS.map(function (n) { return [String(n), n + (n === 9 ? '+ seats' : ' seats')]; }));
    modelSel.disabled = true;
    grid.appendChild(makeSel); grid.appendChild(modelSel); grid.appendChild(seatSel); grid.appendChild(otherText);

    var error = el('p', 'sw-pick__error'); error.setAttribute('role', 'alert'); error.hidden = true;
    var stage = el('div', 'sw-pick__stage'); stage.hidden = true;
    var canvas = el('div', 'sw-pick__canvas');
    var hint = el('p', 'sw-pick__hint', 'Drag to spin');
    var name = el('p', 'sw-pick__name');
    var meta = el('p', 'sw-pick__meta');
    var price = el('div', 'sw-pick__price'); price.hidden = true;
    var question = el('p', 'sw-pick__question', 'Is this the right car?');
    var choices = el('div', 'sw-pick__choices');
    var yes = el('button', 'sw-pick__btn', 'Yes, book a wash'); yes.type = 'button';
    var no = el('button', 'sw-pick__btn sw-pick__btn--ghost', 'No, change it'); no.type = 'button';
    choices.appendChild(yes); choices.appendChild(no);
    var fix = el('div', 'sw-pick__fix'); fix.hidden = true;
    var fixText = el('p', '', 'Pick the shape that looks most like your vehicle.');
    var bodySel = select('Vehicle shape', 'Select vehicle shape');
    fill(bodySel, BODY_ORDER.map(function (k) { return [k, BODIES[k].label]; }));
    fix.appendChild(fixText); fix.appendChild(bodySel);
    stage.appendChild(canvas); stage.appendChild(hint); stage.appendChild(name); stage.appendChild(meta); stage.appendChild(price);
    stage.appendChild(question); stage.appendChild(choices); stage.appendChild(fix);
    var main = el('button', 'sw-pick__btn sw-pick__btn--main', 'Book A Wash'); main.type = 'button';
    root.textContent = '';
    [heading, grid, error, stage, main].forEach(function (n) { root.appendChild(n); });

    var viewer = null, models = [], body = '', busy = false, prices = null, priceJob = null;

    /* Prices are read from the Services page so the two always agree. */
    function loadPrices() {
      if (priceJob) return priceJob;
      priceJob = fetch(servicesUrl, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), found = {}, order = [];
        Array.prototype.forEach.call(doc.querySelectorAll('[data-sw-card]'), function (card) {
          var tier = card.getAttribute('data-tier'), h = card.querySelector('h2,h3'), m = (card.textContent || '').match(/\u00a3\s?([0-9]+(?:\.[0-9]{1,2})?)/);
          if ((tier !== 'hatch' && tier !== 'suv') || !h || !m) return;
          var title = h.textContent.replace(/\s+/g, ' ').trim();
          if (!found[title]) { found[title] = {}; order.push(title); }
          found[title][tier] = '\u00a3' + m[1].replace(/\.00$/, '');
        });
        prices = order.map(function (t) { return { title: t, hatch: found[t].hatch, suv: found[t].suv }; });
        showPrice();
      }).catch(function () { prices = []; });
      return priceJob;
    }
    function isLarge() { return !!body && (BODIES[body].tier === 'suv' || parseInt(seatSel.value, 10) >= 7); }
    function showPrice() {
      price.textContent = '';
      var tier = isLarge() ? 'suv' : 'hatch', shown = 0;
      if (body && prices) prices.forEach(function (p) {
        if (!p[tier]) return;
        var chip = el('span', '', p.title), amount = el('b', '', p[tier]);
        chip.appendChild(amount); price.appendChild(chip); shown += 1;
      });
      price.hidden = !shown;
    }

    function showError(msg) { error.textContent = msg || ''; error.hidden = !msg; }
    function isOther() { return makeSel.value === OTHER || modelSel.value === OTHER; }
    function describe() {
      var make = makeSel.value === OTHER ? '' : makeSel.value;
      var model = modelSel.value === OTHER ? '' : modelSel.value;
      var typed = otherText.value.trim();
      name.textContent = isOther() ? (typed || (make ? make + ' (model not listed)' : 'Your vehicle')) : make + ' ' + model;
      var bits = [];
      if (body) bits.push(BODIES[body].label);
      if (seatSel.value) bits.push(seatSel.value + (seatSel.value === '9' ? '+' : '') + ' seats');
      meta.textContent = bits.join(' · ');
      showPrice();
    }
    function draw() {
      if (!body) return;
      if (viewer) { viewer.show(body); return; }
      loadThree().then(function () {
        if (!viewer) { try { viewer = new Viewer(canvas, colour); } catch (e) { viewer = new FlatViewer(canvas, colour); hint.hidden = true; } }
        if (body) viewer.show(body);
      }, function () {
        if (!viewer) { viewer = new FlatViewer(canvas, colour); hint.hidden = true; }
        if (body) viewer.show(body);
      });
    }
    function update() {
      showError('');
      var ready = !!modelSel.value || makeSel.value === OTHER;
      otherText.hidden = !isOther();
      if (isOther()) { fix.hidden = false; }
      stage.hidden = !ready; main.hidden = ready;
      if (!ready) { if (viewer) viewer.stop(); return; }
      question.textContent = body ? 'Is this the right car?' : 'What shape is your vehicle?';
      canvas.hidden = !body; hint.hidden = !body || (viewer instanceof FlatViewer);
      choices.hidden = !body;
      describe(); draw();
    }

    makeSel.addEventListener('change', function () {
      models = modelsFor(makeSel.value);
      fill(modelSel, models.map(function (m) { return [m.name, m.name]; }).concat(makeSel.value ? [[OTHER, OTHER]] : []));
      modelSel.disabled = !makeSel.value;
      body = ''; bodySel.value = ''; fix.hidden = true; seatSel.value = '';
      if (makeSel.value === OTHER) { modelSel.value = OTHER; modelSel.disabled = true; }
      if (makeSel.value && makeSel.value !== OTHER) loadThree().catch(function () {});
      if (makeSel.value) loadPrices();
      update();
    });
    modelSel.addEventListener('change', function () {
      var m = models.filter(function (x) { return x.name === modelSel.value; })[0];
      fix.hidden = true;
      if (m) { body = m.body; bodySel.value = m.body; seatSel.value = String(m.seats); }
      else { body = ''; bodySel.value = ''; seatSel.value = ''; }
      update();
    });
    seatSel.addEventListener('change', function () { showError(''); describe(); });
    otherText.addEventListener('input', describe);
    bodySel.addEventListener('change', function () { body = bodySel.value; update(); });
    no.addEventListener('click', function () { fix.hidden = false; bodySel.focus(); });
    main.addEventListener('click', function () { showError('Choose your make and model to continue.'); (makeSel.value ? modelSel : makeSel).focus(); });

    yes.addEventListener('click', function () {
      if (busy) return;
      if (!body) { showError('Please pick the shape of your vehicle.'); return; }
      if (!seatSel.value) { showError('Please choose the number of seats.'); seatSel.focus(); return; }
      busy = true; yes.disabled = true; no.disabled = true; yes.textContent = 'Finding Services...';
      var c = BODIES[body], seats = parseInt(seatSel.value, 10), seven = seats >= 7;
      var typed = otherText.value.trim();
      var make = makeSel.value === OTHER ? (typed || 'Other') : makeSel.value;
      var model = makeSel.value === OTHER ? '' : (modelSel.value === OTHER ? (typed || 'Not listed') : modelSel.value);
      var type = c.label + (seven ? ' / 7 Seater' : '');
      /* The services page shows its "your vehicle" prices only when a registration is present. */
      var saved = {
        registration: 'Not provided', make: make, model: model, year: '', color: '',
        bodyType: c.label.toUpperCase(), seats: seats, suv: isLarge(), type: type
      };
      try { sessionStorage.setItem('sw_vehicle', JSON.stringify(saved)); } catch (e) {}
      var attrs = {
        'Vehicle registration': saved.registration, 'Vehicle make': make, 'Vehicle model': model,
        'Vehicle seats': String(seats) + (seats === 9 ? '+' : ''), 'Vehicle colour': '', 'Vehicle type': type
      };
      var go = function () { window.location.href = servicesUrl + (servicesUrl.indexOf('?') > -1 ? '&' : '?') + 'vehicle=1'; };
      var done = false, once = function () { if (!done) { done = true; go(); } };
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      setTimeout(once, 2500);
      try {
        fetch(base + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).then(once, once);
      } catch (e) { once(); }
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { busy = false; yes.disabled = false; no.disabled = false; yes.textContent = 'Yes, book a wash'; }
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sw-pick]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.SmartWashCarPicker = { bodies: BODIES, cars: CARS, modelsFor: modelsFor };
})();
